import { Component, Input } from '@angular/core';
import { AbstractControl } from '@angular/forms';
import { MessageModule } from 'primeng/message';

@Component({
  selector: 'sb-form-error',
  imports: [MessageModule],
  template: `
    @if (shouldShowError()) {
      <p-message severity="error" [variant]="variant" [size]="size" [text]="errorMessage" />
    }
  `,
})
export class FormErrorComponent {
  @Input() control: AbstractControl;

  @Input() errorMessage = 'Dette felt er ikke gyldigt';

  @Input() variant: 'outlined' | 'text' | 'simple' = 'simple';

  @Input() size: 'large' | 'small' = 'small';

  shouldShowError(): boolean {
    return Boolean(this.control?.invalid && this.control?.touched);
  }
}
